// inv/src/pages/solutions/accelerators-incubators/blocks/AcceleratorsHero.jsx
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { Button } from '../../../../components/ui/button.jsx';
import { languagePrefixes } from '../../../../i18n';
import googleLogo from '../../../../pages/authentication/google-logo.svg';

const AcceleratorsHero = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const currentLanguage = (i18n.language || 'en').split('-')[0];
  const prefix = languagePrefixes[currentLanguage] || '';

  const handleSignUpClick = () => {
    navigate(
      `${prefix}/signup?utm_source=signup-button&utm_medium=for-accelerators-incubators-page`
    );
  };

  return (
    <section className="py-16 px-16 sm:px-0 sm:py-24 bg-slate-100">
      <div className="mx-auto max-w-5xl text-center px-4">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-stone-900">
          {t(
            'pageSolutions.AcceleratorsIncubators.t1',
            'Support your startups with investor intelligence and AI-powered matching'
          )}
        </h1>

        <p className="mt-6 text-base sm:text-lg leading-7 text-stone-700 max-w-3xl mx-auto">
          {t(
            'pageSolutions.AcceleratorsIncubators.t2',
            'Crino helps accelerators and incubators identify relevant investors, analyse deal activity, discover comparable startups, and provide cohorts with data-driven fundraising support.'
          )}
        </p>

        <div className="mt-8 flex justify-center">
          <Button
            onClick={handleSignUpClick}
            variant="default"
            size="sm"
            iconLeft={
              <>
                <Mail className="h-4 w-4 mr-2" />
                <img
                  src={googleLogo}
                  alt="Google logo"
                  className="h-4 w-4"
                />
              </>
            }
          >
            {t('pageHome.content.t4')}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default AcceleratorsHero;
